import {
  takeEvery, all, call, put, select,
} from 'redux-saga/effects';

import { message } from 'antd';
import {
  apiGetCategories,
  apiUpdateTransactionCategory,
} from './api';

import {
  actions,
  actionTypes,
  updateTransactionCategoryActions,
  updateTransactionCategoryActionTypes,
} from './actions';

import {
  updateTransaction,
} from '../transactionsService/actions';

function* getExpenseCategories() {
  try {
    yield put(actions.request());
    const { companyId } = yield select((state) => state.appService);
    const response = yield call(() => apiGetCategories(companyId));
    const responseJson = yield response.json();

    yield put(actions.success({
      ...responseJson.data,
    }));
  } catch (error) {
    yield put(actions.error(error));
  }
}

function* watcherGetCategories() {
  yield takeEvery(actionTypes.common, getExpenseCategories);
}

function* updateExpenseCategoryForTransaction({ transactionId, categoryId, categoryName }) {
  try {
    yield put(updateTransactionCategoryActions.request());
    const { companyId } = yield select((state) => state.appService);
    const { account } = yield select((state) => state.accountService);
    const { transactions } = yield select((state) => state.transactionsService);
    const editedTransaction = transactions[transactionId];
    editedTransaction.expense_type = {
      id: categoryId,
      name: categoryName,
    };
    yield put(updateTransaction(editedTransaction));
    const response = yield call(() => apiUpdateTransactionCategory(
      companyId,
      account.id,
      transactionId,
      categoryId,
    ));
    const responseJson = yield response.json();
    yield put(updateTransaction(responseJson.data.items[0]));
    message.success('Saved!');
    yield put(updateTransactionCategoryActions.success());
  } catch (error) {
    console.error(error);
    yield put(updateTransactionCategoryActions.error(error));
  }
}

function* watcherUpdateTransactionCategory() {
  yield takeEvery(updateTransactionCategoryActionTypes.common, updateExpenseCategoryForTransaction);
}

export default function* root() {
  yield all([
    watcherGetCategories(),
    watcherUpdateTransactionCategory(),
  ]);
}
